import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import type { FC } from "react";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	name: string;
	photo?: string;
	onBack: () => void;
};

export const ChatHeader: FC<Props> = ({ name, photo, onBack }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={0.8}
			flexShrink={0}
			px={0.8}
			py={0.8}
			bgcolor={theme.palette.background.paper}
		>
			<IconButton variant="ghost" onClick={onBack}>
				<ChevronLeft size={theme.iconSize.md} color={theme.palette.grey[600]} />
			</IconButton>

			<InitialsAvatar name={name} photo={photo} size={36} />

			<Typography variant="bodyStrong" noWrap flex={1} minWidth={0}>
				{name}
			</Typography>
		</Stack>
	);
};
